/**
 ** Pagination utility functions
 */
//** Basic shape */
// pagination: {
//   maxData: number, // Total amount of data fetched
//   currentPage: number, // Current page number index
//   maxPage: number, // Index of the maximum page visited
// }

/**
 *
 * @param newAmount
 * @param maxData
 * @param displayAmount
 * @returns
 */
export function calculateAmountToFetch(newAmount: number, maxData: number, displayAmount: number): number {
  let difference = 0; // Initialize difference variable
  // If the new amount is less than the maximum pagination value
  if (newAmount < maxData) {
    // If the max pagination value is divisible by the new amount
    if(maxData % newAmount === 0) {
      return 0 ;
    }
    // Calculate difference for non divisible newAmount values
    difference = newAmount - (maxData % newAmount);
  }
  else {
    // Calculate the max value between displayAmount and max
    const maxPaginationAmount = displayAmount > maxData ? displayAmount : maxData;
    // Calculate difference for newAmount values greater than or equal to max
    difference = newAmount - maxPaginationAmount;
  }
  return difference;
}

/**
 * Logic for resetting the pagination object
 * @param difference
 * @param dispatch
 * @param paginatedAssetsData
 * @returns
 */
export function shouldFetchMore(
  difference: number,
  hasNextPage: boolean | undefined,
)
{
  // Update max pagination value
  if(difference === 0) return false;
  if(!hasNextPage) return false;
  return true;
}

/**
 *
 * @param maxPageVisited
 * @param currentPageNumber
 * @param dispatch
 * @param hasNextPage
 * @returns
 */
export function shouldFetchNext(maxPageVisited: number, currentPageNumber: number, hasNextPage: boolean) {
  if (!hasNextPage) return false;
  if (maxPageVisited > currentPageNumber) return false;
  return true;
}
